import myDepartment from './my-department';
import myDepartmentAddressesActionsCreators from './my-department-addresses';
import myDepartmentPhonesActionsCreators from './my-department-phones';

const myDepartmentActionsCreators = {
  ...myDepartment,
  ...myDepartmentAddressesActionsCreators,
  ...myDepartmentPhonesActionsCreators,
};

export default myDepartmentActionsCreators;
